import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon5 } from "../../assets/icons/Fork5.svg";

const WorkingAds = () => {
  const items = [
    {
      title: "Messy, Unclear Ad Data?",
      description:
        "Stop guessing—get accurate, real-time insights into ad performance so you can double down on what’s working.",
    },

    {
      title: "Cross-Platform Confusion?",
      description:
        "No more platform silos. Understand the full user journey across every device and channel.",
    },

    {
      title: "Inconsistent Metrics?",
      description:
        "All your campaign data—aligned, accurate, and easy to act on from a single dashboard.",
    },

    {
      title: "Uncertain ROI?",
      description:
        "See exactly which channels drive value so you can invest where it counts and stop burning budget.",
    },
    {
      title: "Lost Users?",
      description:
        "Know which ads bring users back after uninstalling or lapsing—so you can re-engage them strategically.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"workingAds"}>
        <Content>
          <TextWrapper>
            <Title>Tired of Guessing What’s Working in Your Ads? </Title>
            <Subtitle>
              Are your ads truly driving installs and re-engagements, or just
              burning through your budget? With Grovs Attribution, you’ll know
              exactly which ads fuel growth—so you can stop the waste and double
              down on what works. Say goodbye to uncertainty and hello to
              smarter, data-driven decisions.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon5 color="rgba(29, 38, 77, 0.55)" />
            </ForkWrapper>

            <ItemsWrapper>
              {items.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default WorkingAds;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
